import React from "react";
import Search from "../../../../form/Search";
import { t } from "i18next";

const ChatSearch = ({ onSearch = () => {}, searchValue }) => {
  return (
    <Search
      placeholder={t("Search here")}
      searchValue={searchValue}
      search={onSearch}
    />
  );
};

export default ChatSearch;
